import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Pakiautomaati

  <span style="color:#85c1dc;">**FI:**</span>
  Pakettiautomaatti

  <span style="color:#85c1dc;">**RU:**</span>
  В посылочный терминал
*/
/* @__NO_SIDE_EFFECTS__ */
const m599 = msg(
  mf`Pakiautomaati`,
  mf`Pakettiautomaatti`,
  mf`В посылочный терминал`,
)

export { m599 as 'w.basket.delivery.parcel_terminal' }